export default "__VITE_ASSET__edRSQWvE__"